import Repository, { ErrorlessRepository } from './Repository';
import { RepositoryError } from './errors';

export default Repository;

export {
  ErrorlessRepository,
  RepositoryError,
};
